import Vue from 'vue'
import App from './App.vue'
import Dexie from "dexie";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from "./store";
import router from "./router";
import "@/styles/index.scss";
import 'swiper/css';
import locale from 'element-ui/lib/locale';
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import fanLocale from 'element-ui/lib/locale/lang/zh-TW';
import idLocale from 'element-ui/lib/locale/lang/id';
import en from './lang/en.js';
import id from './lang/id';
import fan from './lang/fan';
import VueI18n from 'vue-i18n';
import { indonesianCurrencyFilter } from './utils/filter';
import { isMobile } from './utils/device';

Vue.use(VueI18n);
Vue.use(indonesianCurrencyFilter);

if (localStorage.getItem("language") == 'zh') {
  localStorage.setItem("language", "id");
}

Vue.prototype.$formatIDR = (value) => {
  const { formatIndonesianCurrency } = require('./utils/filter');
  return formatIndonesianCurrency(value);
};

(function () {
  const setRem = () => {
    const clientWidth = document.documentElement.clientWidth || document.body.clientWidth;

    if (isMobile()) {
      const mobileDesignWidth = 393;
      const scale = clientWidth / mobileDesignWidth;
      document.documentElement.style.fontSize = 39.3 * scale + 'px';
    } else {
      const designWidth = 1920;
      const scale = clientWidth / designWidth;
      document.documentElement.style.fontSize = 192 * scale + 'px';
    }
  };

  setRem();
  window.addEventListener('resize', setRem);
  window.addEventListener('pageshow', (e) => e.persisted && setRem());
})();

const messages = {
  en: { ...enLocale, ...en },
  id: { ...idLocale, ...id },
  fan: { ...fanLocale, ...fan }
};

let i18n = new VueI18n({
  locale: localStorage.getItem("language") || 'id',
  messages
});

if (!localStorage.getItem("language")) {
  localStorage.setItem("language", "id");
}

locale.i18n((key, value) => i18n.t(key, value));
Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) });

import { initGlobalState, loadMicroApp } from 'qiankun';

const actions = initGlobalState({ type: 111, message: "login", router: "" });
actions.onGlobalStateChange((state, prev) => {
  console.log(state.message, state.router);
  console.log("当前版本260130-16：37");
}, true);

Vue.config.productionTip = false;

new Vue({
  i18n,
  render: h => h(App),
  router,
  store,
}).$mount('#app');